import { defineStore } from 'pinia'

const storeName = 'Sidebar'

export const useSidebarStore = defineStore(storeName, {
  state() {
    const menu = '' // 'obras' | 'notificacoes' | 'favoritos'
    return { open: false, menu, titulo: '', hideMobileMenu: false }
  },
  actions: {
    toggle(tipoMenu: string) {
      this.menu = tipoMenu
      this.open = !this.open
    },
    toggleMobile() {
      this.hideMobileMenu = !this.hideMobileMenu
    },
    setTitulo(titulo: string) {
      this.titulo = titulo
    },
    openSideBar() {
      this.open = true;
    },
    setMenu(menu: string) {
      this.menu = menu;
    }
  }
})
